"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _filterOption = _interopRequireDefault(require("../styles/filter-option.css"));

var _modelFilter = _interopRequireDefault(require("./model-filter.props/model-filter.defaultProps"));

var _modelFilter2 = require("./model-filter.props/model-filter.propTypes");

var FilterOption = function FilterOption(_ref) {
  var groupName = _ref.groupName,
      theme = _ref.theme,
      _ref$data = _ref.data,
      label = _ref$data.label,
      id = _ref$data.id,
      updateSelection = _ref.updateSelection,
      selectedOption = _ref.selectedOption,
      enabledOptions = _ref.enabledOptions,
      optionKey = _ref.optionKey;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: _filterOption["default"].listItem + " " + theme['col-xs-6'] + "  " + theme['col-sm-12'] + " " + theme['col-md-6'] + " " + theme['col-lg-4']
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: _filterOption["default"].radio,
    type: "radio",
    id: id,
    value: id,
    name: groupName,
    disabled: !enabledOptions.includes(id),
    checked: selectedOption === id,
    onChange: function onChange(e) {
      return updateSelection(e, optionKey);
    }
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: _filterOption["default"].styledRadio,
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: theme.inputsAndOptions + " " + _filterOption["default"].radioLabel
  }, label)));
};

FilterOption.defaultProps = {
  data: _modelFilter["default"].filters[0].filteringOptions[0],
  theme: {}
};
var _default = FilterOption;
exports["default"] = _default;